import React from 'react';
import { Check, Mic, Zap, BarChart3, Database, GitBranch, Puzzle, ShieldCheck } from 'lucide-react';
import styles from './Features.module.css';

const Features = () => {
  const features = [
    {
      id: 1,
      title: "Live Note-taking",
      description: "Transcribe and analyze all your:",
      points: [
        "Zoom, Google Meet, Microsoft Teams meetings",
        "Phone calls & WhatsApp conversations",
        "In-person meetings – through our AI powered app"
      ],
      icon: <Mic size={ 28 } strokeWidth={ 2 } />,
      color: "#6366f1" // Indigo
    },
    {
      id: 2,
      title: "Meeting Insights",
      description: "",
      points: [
        "AI generated summaries & highlights",
        "Track interruptions, pauses and speaker sentiment",
        "Identify deal risks, churn signals, negative feedback and also highlight opportunities"
      ],
      icon: <Zap size={ 28 } strokeWidth={ 2 } />,
      color: "#eab308" // Yellow
    },
    {
      id: 3,
      title: "Sales Rep Performance Dashboards",
      description: "",
      points: [
        "Gain a complete view of your sales reps' meeting behavior",
        "Deliver instant, personalized coaching to every rep, powered by AI-driven analytics and conversation intelligence"
      ],
      icon: <BarChart3 size={ 28 } strokeWidth={ 2 } />,
      color: "#22c55e" // Green
    },
    {
      id: 4,
      title: "Smart Built-in CRM",
      description: "",
      points: [
        "A smart CRM designed specifically for small and medium businesses, and customized for you",
        "Deals, contacts, tasks, reminders, follow-ups — all synced automatically to give you a holistic view of your customers"
      ],
      icon: <Database size={ 28 } strokeWidth={ 2 } />,
      color: "#ec4899" // Pink
    },
    {
      id: 5,
      title: "Pipeline Clarity & Deal Predictability",
      description: "",
      points: [
        "Get a unified, real-time view of your pipeline, activities, and outcomes",
        "Improve forecasting accuracy with AI-powered deal health scores"
      ],
      icon: <GitBranch size={ 28 } strokeWidth={ 2 } />,
      color: "#8b5cf6" // Violet
    },
    {
      id: 6,
      title: "Integrations & Automation",
      description: "",
      points: [
        "Use our lightweight CRM or sync with Zoho, HubSpot and LeadSquared",
        "Integrate with the tools you already use – Zoom, Google Meet, Google Calendar etc."
      ],
      icon: <Puzzle size={ 28 } strokeWidth={ 2 } />,
      color: "#f97316" // Orange
    }
  ];

  return (
    <section className={ styles.featuresSection }>
      <div className={ styles.container }>
        <div className={ styles.header }>
          <h1>Powerful Features for <span className={ styles.highlight }>Modern Sales Teams</span></h1>
          <p className="subheader_text">Everything you need to close more deals and grow your business</p>
        </div>

        <div className={ styles.featuresGrid }>
          { features.map((feature) => (
            <div
              key={ feature.id }
              className={ styles.featureCard }
              style={ { '--card-color': feature.color } }
            >
              <div
                className={ styles.iconContainer }
                style={ { color: feature.color, backgroundColor: `${feature.color}15` } }
              >
                { feature.icon }
              </div>

              <div className={ styles.contentBlock }>
                <h3>{ feature.title }</h3>
                { feature.description && <p className={ styles.description }>{ feature.description }</p> }

                <ul className={ styles.featurePoints }>
                  { feature.points.map((point, pointIndex) => (
                    <li key={ pointIndex } className={ styles.featurePoint }>
                      <span className={ styles.checkIcon }>
                        <Check size={ 12 } strokeWidth={ 4 } />
                      </span>
                      { point }
                    </li>
                  )) }
                </ul>
              </div>
            </div>
          )) }
        </div>
      </div>
    </section>
  );
};

export default Features;